var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesligar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7167 14.9136C18.8048 13.76 18.0614 12.5689 16.7469 12.3385C15.5168 12.1229 14.2478 12.1291 13.0201 12.3566C11.708 12.5998 10.9761 13.798 11.0755 14.9507L11.0669 14.9539C10.0786 15.3218 9.14758 15.8301 8.30353 16.4623L6.76256 14.9361L6.7632 14.9355L6.76483 14.9338C11.3689 10.272 18.4164 10.2789 23.0275 14.8558L23.0296 14.8579L21.5036 16.3986L21.5029 16.398C20.6528 15.7741 19.7177 15.2753 18.7259 14.9169L18.7167 14.9136ZM5.59567 13.7791L5.01687 14.3635C4.69755 14.6859 4.70005 15.2061 5.02246 15.5255L7.65071 18.1286C7.94001 18.4151 8.39554 18.4465 8.72144 18.2024L9.2893 17.7771C10.0075 17.2391 10.7992 16.807 11.6402 16.4939L12.2791 16.256C12.6493 16.1182 12.869 15.7364 12.8022 15.347L12.7207 14.8722C12.6492 14.456 12.9044 14.0493 13.3196 13.9723C14.3546 13.7805 15.4261 13.7753 16.4632 13.957C16.8791 14.03 17.1382 14.4343 17.0708 14.8512L16.9939 15.3265C16.9307 15.7165 17.1541 16.0962 17.5257 16.2305L18.1675 16.4624C19.0114 16.7673 19.8071 17.1918 20.5305 17.7227L21.1025 18.1426C21.4308 18.3836 21.886 18.3478 22.1725 18.0585L24.7753 15.4304C25.0947 15.108 25.0922 14.5878 24.7697 14.2685L24.1852 13.6895C18.9332 8.47656 10.843 8.46605 5.59567 13.7791Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesligar);
export default __webpack_public_path__ + "static/media/desligar.2f6f1ba143badeb8020d2c691865b3b5.svg";
export { ForwardRef as ReactComponent };